import { Box, Typography } from '@mui/material';
import { RadialBarChart, RadialBar, PolarAngleAxis } from 'recharts';

// AIDEV-NOTE: Gauge de meta — RadialBarChart wrapper. Se goalPercent=null, exibe mensagem textual
interface GaugeChartProps {
  goalPercent: number | null;
  size?: number;
}

export function GaugeChart({ goalPercent, size = 200 }: GaugeChartProps) {
  if (goalPercent === null) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: size,
          height: size
        }}
        data-testid="gauge-no-meta"
      >
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Meta nao configurada
        </Typography>
      </Box>
    );
  }

  const clampedPercent = Math.max(0, Math.min(100, goalPercent));
  const data = [
    { name: 'Meta', value: clampedPercent, fill: clampedPercent >= 100 ? '#4caf50' : '#1976d2' }
  ];

  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }} data-testid="gauge-chart">
      <RadialBarChart
        width={size}
        height={size}
        innerRadius="70%"
        outerRadius="100%"
        data={data}
        startAngle={180}
        endAngle={0}
        barSize={12}
      >
        <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
        <RadialBar dataKey="value" cornerRadius={6} background={{ fill: '#e0e0e0' }} />
      </RadialBarChart>
      <Box
        sx={{
          position: 'absolute',
          top: '55%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center'
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          {clampedPercent.toFixed(0)}%
        </Typography>
        <Typography variant="caption" color="text.secondary">
          da meta
        </Typography>
      </Box>
    </Box>
  );
}
